type FontStyles =
  | 'infinitelySmallFont'
  | 'extraExtraSmallFont'
  | 'extraSmallFont'
  | 'extraSmallBoldFont'
  | 'smallFont'
  | 'smallBoldFont'
  | 'mediumFont'
  | 'mediumBoldFont'
  | 'largeFont'
  | 'largerFont'
  | 'extraLargeFont'
  | 'extraLargeBoldFont'
  | 'xlFont'
  | 'xxlFont'
  | 'xxlFontExtra'
  | 'xxxlFont';

const font = (fontStyle: FontStyles, theme) => `
 font-weight: ${theme.fontStyles[fontStyle].fontWeight};
  font-size: ${theme.fontStyles[fontStyle].fontSize}px;
`;

export const mediumBoldFont = (theme) => font('mediumBoldFont', theme);
export const smallBoldFont = (theme) => font('smallBoldFont', theme);
export const smallFont = (theme) => font('smallFont', theme);
export const extraSmallFont = (theme) => font('extraSmallFont', theme);
